import React from "react";
import classNames from "classnames";
import { isDone, isProject } from "../utils";
import { Props } from "./types";
import styles from "./styles.scss";

function List({
  element,
  height,
  width,
  isHovered,
  hasOvertime,
  onClick,
  onMouseDown,
  onMouseMove,
  onTouchStart,
  onTouchMove,
}: Props) {
  const withStartDate = !!element.startDate && !element.endDate;
  const withEndDate = !element.startDate && !!element.endDate;

  return (
    <svg
      className={classNames(styles.list, {
        [styles.project]: isProject(element),
        [styles.unScheduled]: !element.startDate || !element.endDate,
        [styles.withStartDate]: withStartDate,
        [styles.withEndDate]: withEndDate,
        [styles.completed]: isDone(element),
        [styles.hovered]: isHovered,
      })}
      width={width}
      height={height}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
    >
      <defs>
        <linearGradient id="withStartDate">
          <stop offset="0" stopColor="#395786" />
          <stop offset="50%" stopColor="#DFEBFD" />
        </linearGradient>
        <linearGradient id="withEndDate">
          <stop offset="0" stopColor="#DFEBFD" />
          <stop offset="50%" stopColor="#395786" />
        </linearGradient>
      </defs>
      <path
        fill={
          withStartDate
            ? "url(#withStartDate)"
            : withEndDate
              ? "url(#withEndDate)"
              : undefined
        }
        d={`
            M0 10
            C0 0, 0 0, 10 0
            ${
              !hasOvertime
                ? `
                H${width - 10}
                C${width} 0, ${width} 0, ${width} 10
                `
                : `H${width}`
            }
            V${height}
            L${width - 10} ${height - height * 0.25}
            H${10}
            L0 ${height}
            Z
        `}
      />
      <foreignObject
        x={5}
        y={0}
        width={Math.max(0, width - 10)}
        height={height * 0.75}
      >
        <div className={styles.nameWrapper}>
          <span className={styles.name}>{element.name}</span>
        </div>
      </foreignObject>
    </svg>
  );
}

export { List };
